/* tslint:disable */
/* eslint-disable */
/**
 * FraudFighter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleNextInspectionData
 */
export interface VehicleNextInspectionData {
    /**
     * 
     * @type {string}
     * @memberof VehicleNextInspectionData
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleNextInspectionData
     */
    vehicleReportId?: string;
    /**
     * 
     * @type {Date}
     * @memberof VehicleNextInspectionData
     */
    date?: Date | null;
}

export function VehicleNextInspectionDataFromJSON(json: any): VehicleNextInspectionData {
    return VehicleNextInspectionDataFromJSONTyped(json, false);
}

export function VehicleNextInspectionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleNextInspectionData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'vehicleReportId': !exists(json, 'vehicleReportId') ? undefined : json['vehicleReportId'],
        'date': !exists(json, 'date') ? undefined : (json['date'] === null ? null : new Date(json['date'])),
    };
}

export function VehicleNextInspectionDataToJSON(value?: VehicleNextInspectionData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'vehicleReportId': value.vehicleReportId,
        'date': value.date === undefined ? undefined : (value.date === null ? null : value.date.toISOString()),
    };
}


